import { render, staticRenderFns } from "./PortfolioSectorBreakdownCard.vue?vue&type=template&id=1ab5ee2f&scoped=true&"
import script from "./PortfolioSectorBreakdownCard.vue?vue&type=script&lang=ts&"
export * from "./PortfolioSectorBreakdownCard.vue?vue&type=script&lang=ts&"
import style0 from "./PortfolioSectorBreakdownCard.vue?vue&type=style&index=0&id=1ab5ee2f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab5ee2f",
  null
  
)

export default component.exports